import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/symbols/shipping_providers.svg'


const _withScopeId = n => (_pushScopeId("data-v-20265286"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_0 + '#bpost'
const _hoisted_2 = _imports_0 + '#sendcloud'
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-4" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header py-3" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title d-flex align-items-center gap-3 mb-0" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      height: "20px",
      width: "28px"
    }, [
      /*#__PURE__*/_createElementVNode("use", { href: _hoisted_1 })
    ]),
    /*#__PURE__*/_createElementVNode("span", null, "Bpost")
  ])
], -1))
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mas me-1" }, "settings", -1))
const _hoisted_10 = {
  key: 1,
  class: "bg-warning missing-feature"
}
const _hoisted_11 = { class: "col-lg-4" }
const _hoisted_12 = { class: "card" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header py-3" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title d-flex align-items-center gap-3 mb-0" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      height: "20px",
      width: "20px"
    }, [
      /*#__PURE__*/_createElementVNode("use", { href: _hoisted_2 })
    ]),
    /*#__PURE__*/_createElementVNode("span", null, "Sendcloud")
  ])
], -1))
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mas me-1" }, "settings", -1))
const _hoisted_17 = {
  key: 1,
  class: "bg-warning missing-feature"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('shippingSettings'),
        mb: 4
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", {
                class: "card-text",
                innerHTML: _ctx.$t('pharmaShippingSettingsInfoBpost')
              }, null, 8, _hoisted_8),
              (_ctx.AbilityContext.isAuthorizedForFeature('BPOST_INTEGRATION'))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: { name: 'pharma-shipping-bpost' },
                    class: "btn btn-primary fw-700 d-inline-flex align-items-center"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("configure")), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t("missingFeatureWarning")), 1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("p", {
                class: "card-text",
                innerHTML: _ctx.$t('pharmaShippingSettingsInfoSendcloud')
              }, null, 8, _hoisted_15),
              (
                _ctx.AbilityContext.isAuthorizedForFeature('SENDCLOUD_INTEGRATION')
              )
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: { name: 'sendcloud' },
                    class: "btn btn-primary fw-700 d-inline-flex align-items-center"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("configure")), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.$t("missingFeatureWarning")), 1))
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}